/* ============================================================================
   pzz-bundle-upsell.js  ·  Perfumes Zag Zodiak  (Horizon 3.5.x)
   ----------------------------------------------------------------------------
   Morph-safe renderer for the TAG-MODE bundle upsell widget.

   Loaded ONCE, globally, from layout/theme.liquid — i.e. OUTSIDE any section —
   so it is never wiped or re-parsed by Horizon's Section Rendering API when a
   variant changes. The matching snippet now outputs only an EMPTY, HIDDEN
   placeholder:

     <div class="bundle-upsell" hidden
          data-component-tag="019-bundle"
          data-current-handle="019-an"
          data-currency="GBP"></div>

   Reveal contract (no flash):
     • The placeholder starts hidden + empty, so a product with NO bundle never
       shows a "Bundle & save / Loading…" frame that then disappears.
     • This script reveals + fills the box ONLY when a usable bundle resolves.
     • Resolution state lives on data-pzz-state ('empty' = resolved, no bundle),
       NOT on the [hidden] attribute — because [hidden] is now also the initial
       state. Conflating the two is what caused the old skip-everything bug.

   Why this is morph-safe and fast:
     • A MutationObserver on a stable ancestor re-runs the renderer after every
       morph; the fresh placeholder comes back hidden+empty and is re-resolved.
     • Results are cached per tag-pair, so flipping variants re-renders from
       memory (no network, no race, no flash); no-bundle re-hides instantly.
   ============================================================================ */
(function () {
  if (window.__pzzBundleUpsell) return;
  window.__pzzBundleUpsell = true;

  var cache = new Map();        // 'componentTag|bundleTag' -> {components, bundleProduct} | null | Promise
 var inFlight = new WeakSet(); // nodes currently resolving
  var selfWriting = false;      // true while renderInto writes, so the observer
                                // ignores its own innerHTML mutation (microtask-timed)

  // Only wake the renderer for mutations that actually touched a bundle-upsell —
  // not for the constant DOM churn of Judge.me, lazy images, predictive search,
  // etc. Previously EVERY childList change under <main> scheduled a full
  // initAll(); this narrows it to the handful of morphs that matter, which is
  // the difference during a variant-change interaction (INP window).
  function relevantMutation(records) {
    for (var i = 0; i < records.length; i++) {
      var m = records[i];
      if (m.target && m.target.closest && m.target.closest('.bundle-upsell')) return true;
      var nodes = m.addedNodes || [];
      for (var j = 0; j < nodes.length; j++) {
        var n = nodes[j];
        if (n.nodeType !== 1) continue;
        if ((n.matches && n.matches('.bundle-upsell[data-component-tag]')) ||
            (n.querySelector && n.querySelector('.bundle-upsell[data-component-tag]'))) {
          return true;
        }
      }
    }
    return false;
  }

  /* ---- helpers ---------------------------------------------------------- */

  function currencyFor(root) {
    return (
      root.getAttribute('data-currency') ||
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
      'GBP'
    );
  }

  var _fmtCache = {};
    function formatter(root) {
      var cur = currencyFor(root);
      return _fmtCache[cur] || (_fmtCache[cur] = new Intl.NumberFormat('en-GB', { style: 'currency', currency: cur }));
    }

  function toMoney(fmt, value) {
    var n = parseFloat(value);
    return isNaN(n) ? '' : fmt.format(n);
  }

  function sizedImage(url, width) {
    if (!url) return '';
    try {
      var u = new URL(url, window.location.origin);
      u.searchParams.set('width', width);
      return u.toString();
    } catch (e) {
      return url;
    }
  }

  function esc(str) {
    return (str || '').replace(/"/g, '&quot;');
  }
  // Order components: shower gel first, perfume second, everything else after
// (body balm for women's, aftershave for men's, etc.).
function componentRank(prod) {
  var type  = (prod.product_type || '').toLowerCase();
  var title = (prod.title || '').toLowerCase();

  // Slot 0 — shower gel
  if (type.indexOf('shower') !== -1 || title.indexOf('shower gel') !== -1) return 0;

  // Slot 1 — perfume / the scent
  if (type.indexOf('perfume') !== -1 || type.indexOf('parfum') !== -1) return 1;

  // Everything else (balm, aftershave, anything new) — slot 2, keep fetch order
  return 2;
}

function orderComponents(list) {
  // Stable sort by slot; items sharing a slot keep their original fetch order.
  return list
    .map(function (prod, i) { return { prod: prod, i: i }; })
    .sort(function (a, b) {
      var r = componentRank(a.prod) - componentRank(b.prod);
      return r !== 0 ? r : a.i - b.i;
    })
    .map(function (x) { return x.prod; });
}

  /* ---- state ------------------------------------------------------------ */

  function isRendered(root) {
    return !!root.querySelector('.bundle-upsell__components');
  }

  // Resolved, but there is no usable bundle: keep it hidden and empty, and mark
  // it so we never re-process it on subsequent observer cycles.
  function markEmpty(root) {
    root.dataset.pzzState = 'empty';
    if (!root.hasAttribute('hidden')) root.setAttribute('hidden', '');
    // Tag bundle unusable (sold out / too few products): reveal the featured
    // fallback for this product, if one was server-rendered.
    var pid = (root.id || '').replace('bundle-upsell-', '');
    if (pid) {
      var fb = document.querySelector('[data-pzz-featured-fallback-for="' + pid + '"]');
      if (fb) fb.removeAttribute('hidden');
    }
  }

  /* ---- data fetching (fast tag endpoint, safe full-scan fallback) ------- */

  function fetchByTag(tag, limit) {
    limit = limit || 12;
    var url = '/collections/all/' + encodeURIComponent(tag) + '/products.json?limit=' + limit;
    return fetch(url)
      .then(function (res) {
        if (!res.ok) throw new Error('tag endpoint ' + res.status);
        return res.json();
      })
      .then(function (data) {
        var list = (data && data.products) || [];
        return list.length ? list : fetchByFullScan(tag);
      })
      .catch(function () {
        return fetchByFullScan(tag);
      });
  }

  function fetchByFullScan(tag) {
    var all = [];
    function page(p) {
      return fetch('/collections/all/products.json?page=' + p + '&limit=250')
        .then(function (res) { return res.ok ? res.json() : { products: [] }; })
        .then(function (data) {
          var list = (data && data.products) || [];
          all = all.concat(list);
          if (list.length === 250 && p < 8) return page(p + 1);
          return all.filter(function (prod) {
            return prod.tags && prod.tags.indexOf(tag) !== -1;
          });
        });
    }
    return page(1).catch(function () { return []; });
  }

  // Resolves (and caches) the {components, bundleProduct} pair for a tag, ors  
  // null when there is no usable bundle. The Promise itself is cached so that
  // concurrent widgets / rapid variant flips share a single network round-trip.
  function resolve(componentTag, bundleTag) {
    var key = componentTag + '|' + bundleTag;
    if (cache.has(key)) return Promise.resolve(cache.get(key));

    var promise = Promise.all([fetchByTag(componentTag, 6), fetchByTag(bundleTag, 1)])
      .then(function (results) {
        var components = orderComponents(results[0] || []).slice(0, 3);
        var bundleProduct = (results[1] || [])[0];
        var bundleAvailable =
          bundleProduct &&
          (bundleProduct.available ||
            (bundleProduct.variants && bundleProduct.variants[0] && bundleProduct.variants[0].available));
        var out = (bundleAvailable && components.length)
          ? { components: components, bundleProduct: bundleProduct }
          : null;
        cache.set(key, out);
        return out;
      })
      .catch(function () {
        cache.set(key, null);
        return null;
      });

    cache.set(key, promise); // dedupe in-flight callers
    return promise;
  }

  /* ---- rendering -------------------------------------------------------- */

  function renderInto(root, data) {
    var fmt = formatter(root);
    var components = data.components;
    var bundleProduct = data.bundleProduct;
    var currentHandle = root.getAttribute('data-current-handle');

    // Never upsell the product back to itself.
    if (bundleProduct.handle === currentHandle) { markEmpty(root); return; }

    var variant = (bundleProduct.variants && bundleProduct.variants[0]) || null;
    var price = variant ? variant.price : bundleProduct.price;
    var compareAt = variant ? variant.compare_at_price : null;
    var hasSaving = compareAt && parseFloat(compareAt) > parseFloat(price);

    var componentsHtml = components.map(function (prod, index) {
      var img = prod.featured_image || (prod.images && prod.images[0]) || '';
      var src = typeof img === 'object' ? (img.src || img.url) : img;
      var card =
        '<a class="bundle-upsell__component" href="/products/' + prod.handle + '">' +
          (src
            ? '<img class="bundle-upsell__media" src="' + sizedImage(src, 300) + '" alt="' +
                esc(prod.title) + '" loading="lazy" width="300" height="300">'
            : '') +
          '<p class="bundle-upsell__component-title">' + (prod.title || '') + '</p>' +
        '</a>';
      return index < components.length - 1
        ? card + '<span class="bundle-upsell__plus" aria-hidden="true">+</span>'
        : card;
    }).join('');

    var priceHtml =
      '<p class="bundle-upsell__price">' +
        (hasSaving ? '<span class="bundle-upsell__price-compare">' + toMoney(fmt, compareAt) + '</span>' : '') +
        '<span class="bundle-upsell__price-current">' + toMoney(fmt, price) + '</span>' +
      '</p>';

    var saveHtml = hasSaving
      ? '<p class="bundle-upsell__save">Save <strong>' +
          toMoney(fmt, parseFloat(compareAt) - parseFloat(price)) + '</strong> with this bundle</p>'
      : '';

    // Tag-mode upsells always point at pre-combined fixed bundle products, so
    // they add straight to cart. resolve() already guarantees the bundle is
    // available; we just need a usable variant id, falling back to a link if
    // (unexpectedly) there isn't one.
    var firstVariant = variant;
    var canDirectAdd = !!(firstVariant && firstVariant.id != null);

    root.dataset.pzzState = 'done';
    root.removeAttribute('hidden');
    root.innerHTML =
      '<h3 class="bundle-upsell__title">Bundle &amp; save</h3>' +
      '<div class="bundle-upsell__components">' + componentsHtml + '</div>' +
      priceHtml + saveHtml +
      '<div class="bundle-upsell__actions"></div>';

    var actions = root.querySelector('.bundle-upsell__actions');

    if (canDirectAdd) {
      // Clone the server-rendered native <product-form-component> (it carries the
      // real {% form %}, refs and theme SVGs) and stamp in the fetched variant.
      // The theme's own elements upgrade on insertion and run the whole add —
      // instant burst + fly-to-cart, native /cart/add, drawer + bubble refresh.
      var tpl = document.querySelector('[data-pzz-addtocart-template]');
      var placed = false;
      if (tpl && tpl.content) {
        var frag = tpl.content.cloneNode(true);

        var idInput = frag.querySelector('input[name="id"]');
        if (idInput) {
          idInput.value = firstVariant.id;
          placed = true;
        }

        // Correct the event-detail product id (cosmetic but tidy).
        var pfc = frag.querySelector('product-form-component');
        if (pfc && bundleProduct.id != null) {
          pfc.setAttribute('data-product-id', bundleProduct.id);
        }

        // Point the fly-to-cart image at the bundle's own image.
        var atc = frag.querySelector('add-to-cart-component');
        if (atc) {
          var fi = bundleProduct.featured_image || (bundleProduct.images && bundleProduct.images[0]) || '';
          var src = typeof fi === 'object' ? (fi.src || fi.url) : fi;
          if (src) atc.setAttribute('data-product-variant-media', sizedImage(src, 100));
        }

        if (placed) actions.appendChild(frag);
      }
      if (!placed) {
        // Template missing / malformed — fall back to a link to the bundle.
        actions.innerHTML =
          '<a class="bundle-upsell__cta bundle-upsell__cta--primary" href="/products/' +
          bundleProduct.handle + '">View bundle</a>';
      }
    } else {
      actions.innerHTML =
        '<a class="bundle-upsell__cta bundle-upsell__cta--primary" href="/products/' +
        bundleProduct.handle + '">Build this bundle</a>';
    }
    selfWriting = false;   // ← add this, end of renderInto
  }

  /* ---- orchestration ---------------------------------------------------- */

  function processOne(root) {
    if (inFlight.has(root)) return;              // already resolving
    if (root.dataset.pzzState === 'empty') return; // resolved: no bundle, stays hidden
    if (isRendered(root)) return;                // resolved: bundle already shown

    var raw = (root.getAttribute('data-component-tag') || '').replace(/[\[\]"]/g, '').trim();
    if (!raw) return;
    var bundleTag = /-product$/.test(raw) ? raw : raw + '-product';

    inFlight.add(root);
    resolve(raw, bundleTag)
      .then(function (data) {
        inFlight.delete(root);
        if (!data) { markEmpty(root); return; }
        renderInto(root, data);
      })
      .catch(function () {
        inFlight.delete(root);
        markEmpty(root);
      });
  }

  function initAll() {
    document.querySelectorAll('.bundle-upsell[data-component-tag]').forEach(processOne);
  }

  var debounce;
  function schedule() {
    clearTimeout(debounce);
    debounce = setTimeout(initAll, 120);
  }

  function start() {
    initAll();
    // Stable ancestor that survives section morphs — re-run after each morph,
    // but ONLY when the mutation actually involved a bundle-upsell (see
    // relevantMutation), and never for our own innerHTML writes (selfWriting).
    var target = document.querySelector('main') || document.body;
    var observer = new MutationObserver(function (records) {
      if (selfWriting) return;
      if (relevantMutation(records)) schedule();
    });
    observer.observe(target, { childList: true, subtree: true });
    // Theme-editor section reloads + Safari bfcache restores.
    document.addEventListener('shopify:section:load', schedule);
    window.addEventListener('pageshow', initAll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();